module.exports = __webpack_public_path__ + "static/img/29.af29e2f8.jpeg";